import { render, staticRenderFns } from "./ProductCategoryListScreen.vue?vue&type=template&id=f27445ea&"
import script from "./ProductCategoryListScreen.vue?vue&type=script&lang=ts&"
export * from "./ProductCategoryListScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports